import { createContext } from 'react';

export interface ModalState {
  isOpen: boolean;
  isLoading: boolean;
  isFormDirty: boolean;
}

export interface LeaveGuardModalConfig {
  headerText: string;
  body: string;
  cancelLabelText: string;
  submitLabelText: string;
  onCancel: () => void;
  onSubmit: () => void;
  submitIsLoading?: boolean;
}

interface ModalActions {
  toggleModal: () => void;
  closeModal: () => void;
  setIsFormDirty: (isDirty: boolean) => void;
  setIsLoading: (isLoading: boolean) => void;
  registerLeaveGuardConfig: (config: LeaveGuardModalConfig | null) => void;
}

export type ContextValue = ModalState & ModalActions & { modalConfig: LeaveGuardModalConfig | null };

export const LeaveGuardModalContext = createContext<ContextValue | undefined>(undefined);
